import React, { useContext, useState } from "react";

import { Menu, MenuItem } from "@material-ui/core";

import { Button} from "../../../../../common/components/libs";
import { localize } from "../../../../../common/libs";
import { observer } from "mobx-react";
import { useStores } from "../../../../../hooks";
import { SnackbarType } from "../../../../../stores/common";
import ClientOrdersStoreContext from "../store/context";
import {Trans, useTranslation} from "react-i18next";


const ChooseMenu = () => {
    const [menuSelectorAnchorEl, setMenuSelectorAnchorEl] = useState<HTMLElement | null>(null);
    const ordersStore = useContext(ClientOrdersStoreContext);
    const {generalStore} = useStores();
    const filter = ordersStore.filter;
    const {i18n, t} = useTranslation(["general"]);
    const locale = i18n.language;


    const handleOpenMenuSelectorMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setMenuSelectorAnchorEl(event.currentTarget);
    };

    const setMenu = (menuId: number) => {
        setMenuSelectorAnchorEl(null);
        ordersStore.setOrdersFilter({
            ...filter,
            menusIds: [menuId],
        });
        ordersStore.reloadOrders();
        generalStore.showSnackbar({
            type: SnackbarType.success,
            title: t("general:labelOfUpdating")
        })
    };
    const selectedMenuId = ordersStore.filter.menusIds[0];
    const current = ordersStore.getMenuById(selectedMenuId);

    console.log(selectedMenuId, current);

    return (
        <React.Fragment>

            <Button
                variant="contained"
                aria-owns={menuSelectorAnchorEl ? "menu-selector" : undefined}
                aria-haspopup="true"
                onClick={handleOpenMenuSelectorMenu}
                mr={5}
            >
                {current && localize(current.data.name)}
            </Button>
            <Menu
                id="menu-selector"
                anchorEl={menuSelectorAnchorEl}
                open={Boolean(menuSelectorAnchorEl)}
                onClose={() => setMenuSelectorAnchorEl(null)}
            >
                {
                    ordersStore.menusList.map(item => {
                        return <MenuItem
                            key={item.id}
                            onClick={() => {
                                setMenu(item.id);
                            }}
                        >
                            {localize(item.data.name)}
                        </MenuItem>
                    })
                }
            </Menu>
        </React.Fragment>
    );
};


export default observer(ChooseMenu);
